import React from "react";
import { I18n } from "@aws-amplify/core";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import Grid from "@material-ui/core/Grid";

import CloseIcon from "../../Common/CloseIcon";
import CustomButton from "../../Common/CustomButton";

import images from "../../../assets/img/images";
import {
  ENROLLMENT_DONE,
  ENROLLMENT_FAILED,
} from "../../../constants/profiles";

const EnrollmentStatus = (props) => {
  const { profileId, close, classes, addAnotherProfile, status } = props;

  return (
    <Grid
      container
      direction="column"
      alignItems="stretch"
      style={{ height: "100%", width: "400px" }}
      wrap="nowrap"
    >
      <Grid item>
        <Grid container direction="row-reverse">
          <Grid item xs={2} className={classes.closeBtn}>
            <CloseIcon closeFunction={close} />
          </Grid>
          <Grid item xs={8} />
        </Grid>
      </Grid>
      <Grid item xs style={{ padding: "0px 48px 24px 48px" }}>
        <Grid container direction="column" alignItems="center">
          <Grid item className="text-54 text-center bold-500">
            {status === ENROLLMENT_DONE && I18n.get("profiles_profileEnrolled")}
            {status === ENROLLMENT_FAILED &&
              I18n.get("profiles_profileEnrollmentFailed")}
          </Grid>
          <Grid item style={{ margin: "12px 0px 38px 0px" }}>
            {status === ENROLLMENT_DONE && (
              <img src={images.successIcon} alt="success" />
            )}
            {status === ENROLLMENT_FAILED && (
              <img src={images.errorIcon} alt="fail" />
            )}
          </Grid>
          <Grid item className={classes.postCreationBtn}>
            <Link
              to={"/profiles/" + profileId}
              style={{ textDecoration: "none", fontSize: "inherit" }}
            >
              <CustomButton color="primary">
                {I18n.get("profiles_goToProfile")}
              </CustomButton>
            </Link>
          </Grid>
          <Grid item className={classes.postCreationBtn}>
            <CustomButton color="primary" onClick={addAnotherProfile}>
              {I18n.get("profiles_addAnotherProfile")}
            </CustomButton>
          </Grid>
          <Grid item className={classes.postCreationBtn}>
            <CustomButton color="primary" onClick={close}>
              {I18n.get("site_close")}
            </CustomButton>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

EnrollmentStatus.propTypes = {
  profileId: PropTypes.string.isRequired,
  close: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  addAnotherProfile: PropTypes.func.isRequired,
  status: PropTypes.oneOf([ENROLLMENT_DONE, ENROLLMENT_FAILED]),
};

export default EnrollmentStatus;
